<template>
  <div style="height:100%">
    <!-- <SplitContainer2 style="height:100%" layout="horizontal">
      <template #table1> -->
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="PropertyManage_Table1" :fields="fields" :title="table_title.title1"
        :show_check="true" :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[1, 1, 0, 0, 0]" @current_changed="current_changed"
        @on_cell_button_click="on_cell_button_click" tableref="eeb03add0b3d4ffd8781a09c4f9db6f9">
        <template #query>
          权限名称：<el-input size="small" v-model="privilegeName" style="width: 120px"></el-input>
        </template>
        <!-- <template #toolbar="">
          <el-button type="info" plain @click="createForm('new')" style="width: 55px" class="ml-2 iconfont icon-add-new" size="mini"></el-button>
        </template> -->
        <!-- <template #operation>
          <el-button type="success" plain size="mini" class="iconfont icon-save">&nbsp;保存</el-button>
        </template> -->
      </TableMain>
    </BaseContainer>
    <!--</template>
       <template #table2>
        <BaseContainer style="height:100%" class="one_table">
          <TableMain name="two table" :fields="fields" :show_query_container="false" ref="TestTable2" title="权限角色列表" tableref="3bdf4c7a22aa48a68f1b49ee9c1b7c45">
            <template #operation>
              <el-button type="success" plain size="mini" class="iconfont icon-save">&nbsp;保存</el-button>
            </template>
          </TableMain>
        </BaseContainer>
      </template>
    </SplitContainer2> -->
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-col :span="12">
            <el-form-item label="权限名称" prop="name">
              <el-input v-model="dataForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="权限类别" prop="category">
              <el-input v-model="dataForm.category"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="description">
              <el-input type="textarea" v-model="dataForm.description"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as api from "../../shared/api"
import SplitContainer2 from "../components/container/SplitContainer2"
import * as PropertyManageController from "../../controllers/system/PropertyManageController"

export default {
  name: "PropertyManage",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer2,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_property",
      },
      modal_title: "create_privilege",
      fields: PropertyManageController.fields,
      dataForm: _.cloneDeep(PropertyManageController.dataForm),
      rules: PropertyManageController.rules,
      privilegeName: "",
    }
  },
  created() { },
  methods: {
    //#region 查询
    ///获取权限列表
    async on_query(set_data) {
      let _this = this
      let _result = await PropertyManageController.methods.getData()
      if (!_.isEmpty(this.privilegeName)) {
        _result = _.filter(_result, (t) => {
          return t.name.indexOf(_this.privilegeName) > -1
        })
      }
      if (_result && _result.length > 0) {
        set_data(_.orderBy(_result, ["id"], ["asc"]))
      } else {
        set_data([])
      }
    },
    ///cell click
    async on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.createForm("edit")
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_privilege"
          this.dataForm = _.cloneDeep(PropertyManageController.dataForm)
          break
        case "edit":
          title = "edite_privilege"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    saveData(cb) {
      let _this = this
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          ///保存数据
          let _items = []
          _items.push(_data)
          let _result = await PropertyManageController.methods.upData({
            selected_items: _items,
          })
          if (_result.Success) {
            ///成功
            let _m = _.find(_this.$refs.PropertyManage_Table1.my_data, {
              id: _this.dataForm.id,
            })
            for (var i in _this.dataForm) {
              _m[i] = _this.dataForm[i]
            }
            cb(true, true)
          } else {
            ///失败
            cb(true, false, "错误：" + JSON.stringify(_result.BatchResult))
          }
        } else {
          cb(false)
          return false
        }
      })
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (
        data.state == "approved" ||
        data.state == "unapproved" ||
        data.state == "deleted"
      ) {
        cb(false)
        return
      }
      let _result = await PropertyManageController.methods.upData(data)
      if (_result.Success) {
        ///成功
        _.each(data.selected_items, (t) => {
          let _m = _.find(this.$refs.PropertyManage_Table1.my_data, {
            id: t.id,
          })
          if (_m) {
            _m.is_valid = data.state === "valid"
          }
        })
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      } else {
        ///失败
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#endregion

    current_changed(old, current) {

      this.$emit("current_changed", old, current)
    },
  },
}
</script>
